export default __webpack_public_path__ + "static/media/project.d2ac81d2.jpg";